import {
  SET_SELECTED_REPORT,
  SET_SELECTED_DASHBOARD,
  UPDATE_SELECTION_TABLE_PREFERENCES,
} from "../actions/selectedActions";

export default function selection(state = { report: null, dashboard: null }, action) {
  switch (action.type) {
    case SET_SELECTED_REPORT: {
      const newState = { report: action.report };
      return { ...state, ...newState };
    }
    case SET_SELECTED_DASHBOARD: {
      const newState = { dashboard: action.dashboard };
      return { ...state, ...newState };
    }
    case UPDATE_SELECTION_TABLE_PREFERENCES: {
      const newState = { ...state };
      newState.selectionPreferences = action.selectionPreferences;
      return newState;
    }
    default:
      return state;
  }
}
